import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { editLibraryComment } from 'api/company';
import { getLibraryComment } from 'api/pathForHook/company';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import Title from 'components/backoffice/texts/title';
import FiltersTableCommentsLibrary from './FiltersTableCommentsLibrary';
import CustomCheckbox from 'components/backoffice/customCheckbox';
import ModalCustom from 'components/backoffice/modals/ModalCustom';

const CommentsLibrary = () => {
  const { t } = useTranslation(['backoffice']);
  const [listComments, setListComments] = useState([]);
  const [page, setPage] = useState(1);
  const [formFilter, setFormFilter] = useState({});
  const [responseInfo, setResponseInfo] = useState({});
  const { setTitle } = useOutletContext()
  const [showModal, setShowModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);

  const colsComments = [
    t('commentLibrary.user'),
    t('commentLibrary.library'),
    t('commentLibrary.comment'),
    t('commentLibrary.show')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListCommentsLibrary = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        user: formFilter.user || '',
        library: formFilter.library || '',
        show: formFilter.show || '',
      }
      await fetchData(getLibraryComment(), payload);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    setTitle(t('commentLibrary.title'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListComments(results);
      setResponseInfo({ errors, totalPages, noResults })
    } else {
      setListComments(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    getListCommentsLibrary();
  }, [page, formFilter]);

  const handleClear = () => {
    setFormFilter({
      user: '',
      library: '',
      show: '',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }))
    getListCommentsLibrary();
  };

  const handleShow = async (commentId, show) => {
    try {
      const response = await editLibraryComment(commentId, { show });
      if (response.status === 200) {
        getListCommentsLibrary();
        toast.success(t('editadocorrectamente'));
      } else {
        toast.error(`${t('error')}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      toast.error(`${t('error')}: ${error.message}`, { theme: 'colored' });
    }
  }

  const handleShowModal = (comment) => {
    setSelectedComment(comment);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedComment(null);
  };

  return (
    <div className="h-auto custom-grid">
      <Title text={t('commentLibrary.title')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={12} xs={12} className="d-flex text-start">
          <FiltersTableCommentsLibrary
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            handleClear={handleClear}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsComments}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listComments &&
            listComments.map((comment) => {
              return (
                <tr key={comment.id}>
                  <td>{comment.user}</td>
                  <td>{comment.library}</td>
                  <td>
                    {comment.comment.substring(0, 50)}
                    {comment.comment.length > 50 && '...'}
                    {comment.comment.length > 50 && (
                      <Button
                        size='sm'
                        variant='link'
                        className='bg-primary-color link'
                        onClick={() => handleShowModal(comment)}
                      >
                        {t('seeMore')}
                      </Button>
                    )}
                  </td>
                  <td>
                    <CustomCheckbox
                      className='d-flex justify-content-end'
                      checked={comment.show}
                      onChange={(e) => handleShow(comment.id, e.target.checked)}
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <ModalCustom
        show={showModal}
        onHide={handleCloseModal}
        title={t('commentLibrary.title').slice(0, -1)}>
        {selectedComment && (
          <span className='text-break'>{selectedComment.comment}</span>
        )}
      </ModalCustom>
    </div>
  );
};

export default CommentsLibrary;
